import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiServiceService} from '../Service/api-service.service';

@Component({
  selector: 'app-election',
  templateUrl: './election.component.html',
  styleUrls: ['./election.component.css']
})
export class ElectionComponent implements OnInit {

  resultELC: Observable<object[]>;

  constructor(public apiServiceService: ApiServiceService) {
  }

  getListElection(): void {
    this.apiServiceService.getElections('2020').subscribe(Result => this.resultELC = Result['results']);
  }

  ngOnInit() {
    this.getListElection();
  }



}
